export const init = () => {
  const player = document.querySelector('.js-audio-player');
  if (!player) return;

  const audio = player.querySelector('.js-audio-player-source');
  const playPauseBtn = player.querySelector('.js-audio-player-play\\/pause');
  const backwardBtn = player.querySelector('.js-audio-player-backward');
  const forwardBtn = player.querySelector('.js-audio-player-forward');
  const muteBtn = player.querySelector('.js-audio-player-mute\\/unmute');
  const slider = player.querySelector('.js-audio-player-slider');
  const currentTimeEl = player.querySelector('.js-audio-player-current-time');
  const durationEl = player.querySelector('.js-audio-player-duration');

  if (!audio || !slider) return;

  // Format mm:ss
  function formatTime(sec) {
    if (isNaN(sec)) return '0:00';
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }

  // Update slider gradient
  function updateSliderStyle() {
    const percentage = (slider.value / slider.max) * 100;
    slider.style.background = `linear-gradient(to right, #03123D 0%, #03123D ${percentage}%, #E6E6E6 ${percentage}%, #E6E6E6 100%)`;
  }

  // Update time and slider
  function updateTime() {
    slider.value = audio.currentTime;
    if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
    updateSliderStyle();
  }

  // Load duration
  audio.addEventListener('loadedmetadata', () => {
    slider.max = isNaN(audio.duration) ? 0 : audio.duration;
    if (durationEl) durationEl.textContent = formatTime(audio.duration);
    updateSliderStyle();
  });

  // Update during playback
  audio.addEventListener('timeupdate', updateTime);

  //After playback ends
  audio.addEventListener('ended', () => {
    audio.currentTime = 0;
    updateTime();
    if (playPauseBtn) playPauseBtn.classList.remove('active');
  });

  // Seek
  slider.addEventListener('input', () => {
    audio.currentTime = slider.value;
    updateTime();
  });

  // Play/Pause
  if (playPauseBtn) {
    playPauseBtn.addEventListener('click', () => {
      if (audio.paused) {
        audio.play();
        playPauseBtn.classList.add('active');
      } else {
        audio.pause();
        playPauseBtn.classList.remove('active');
      }
    });
  }

  // Backward
  if (backwardBtn) {
    backwardBtn.addEventListener('click', () => {
      audio.currentTime = Math.max(0, audio.currentTime - 15);
      updateTime();
    });
  }

  // Forward
  if (forwardBtn) {
    forwardBtn.addEventListener('click', () => {
      audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 30);
      updateTime();
    });
  }

  // Mute toggle
  if (muteBtn) {
    muteBtn.addEventListener('click', () => {
      audio.muted = !audio.muted;
      muteBtn.classList.toggle('active', audio.muted);
    });
  }
};
